export default __webpack_public_path__ + "static/media/clinics.58d1d7df.svg";